export default __webpack_public_path__ + "static/media/download-guia-paciente.02442507.pdf";